// extracted by mini-css-extract-plugin
export default {"spacePie":"Knob_spacePie__Iz+ap","messageError":"Knob_messageError__j0YV-"};